import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from 'src/libs/angular/core/src/lib/environments/environment';

@Component({
  selector: 'aa-ai-section',
  standalone: true,
  imports: [],
  templateUrl: './ai-section.component.html',
  styleUrl: './ai-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiSectionComponent {
  customerAppURLBase = environment.customerAppURL;
}
